import axios from "axios";

export const fetchData = async (
  searchQuery,
  setLoading,
  setMerchants,
  setData,
  setLowestPrice,
  postalCode
) => {
  setLoading(true);
  try {
    const response = await axios.get(
      "https://cdn-gateflipp.flippback.com/bf/flipp/items/search",
      {
        params: {
          locale: "en-ca",
          postal_code: postalCode || "N2M5C7",
          sid: "",
          q: searchQuery || "Vegetables",
        },
      }
    );

    const items = response.data.items || [];
    const ecomItems = response.data.ecom_items || [];

    // Combine all products (flyer + ecom items)
    const allItems = [...items, ...ecomItems];

    if(allItems && allItems.length === 0) {
      setData(allItems);
    }

    // Filter out items without prices
    const filterAll = allItems.filter((item) => {
      return (
        (item.original_price !== null || item.current_price !== null) &&
        (item.merchant !== null || item.merchant_name !== null)
      );
    });

    // Find the lowest price product
    const lowest = filterAll.reduce((min, item) =>
      item.current_price < min.current_price ? item : min
    );

    // Remove the lowest price product from the list
    // const remainingItems = filterAll.filter((item) => item.id !== lowest.id);

    // Sort remaining products by price (cheapest to expensive)
    const sortedItems = filterAll.sort(
      (a, b) =>
        a.current_price - b.current_price || a.original_price - b.original_price
    );

    // Set the data for both lowest price product and the sorted list
    setData(sortedItems);
    setLowestPrice(lowest);

    // Fetch merchants based on sortedItems
    const allMerchantsWithProducts = sortedItems.reduce((acc, product) => {
      const merchant = product.merchant || product.merchant_name;

      const { merchant_logo } = product;

      if (
        merchant &&
        (product.current_price !== null || product.original_price !== null)
      ) {
        // Check if merchant already exists in the accumulator
        const exists = acc.some((m) => m.name === merchant);
        if (!exists) {
          acc.push({ name: merchant, logo: merchant_logo });
        }
      }

      return acc;
    }, []);

    // Set only merchants with associated products
    if (allMerchantsWithProducts.length > 0) {
      setMerchants(allMerchantsWithProducts);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    setLoading(false);
  }
};